import noObserve from 'src/services/noObserve';

const noObserveMixin = {
  computed: {
    $noObserve() {
      return {
        get: (name) => noObserve.get(this._uid, name), // eslint-disable-line no-underscore-dangle
        remove: (name) => {
          noObserve.remove(this._uid, name); // eslint-disable-line no-underscore-dangle
        },
        set: (name, value) => {
          noObserve.set(this._uid, name, value); // eslint-disable-line no-underscore-dangle
        },
      };
    },
  },
};

export default noObserveMixin;
